import { getDeviceData } from '@finteqhub/sdk-js/dist/src/utils';
import { v4 as uuidv4 } from 'uuid';

import { PreprocessorTypes } from '@cashier/cashier-model';

import { ItemEnricher } from './model';

const DEVICE_DATA: { [key: string]: string | boolean | number } = {
  ...getDeviceData().device.browser,
  fingerprint: uuidv4().replaceAll('-', ''),
  type: getDeviceData().device.type,
  javaEnabled: String(getDeviceData().device.browser.javaEnabled),
  javaScriptEnabled: String(getDeviceData().device.browser.javaScriptEnabled),
};

export const SdkSessionDataEnricher: ItemEnricher = {
  shouldEnrich: (field, { preprocessor }) =>
    !!preprocessor &&
    [
      PreprocessorTypes.TOKENIZER_V1,
      PreprocessorTypes.PAYLOAD_ENRICHER_V1,
    ].includes(preprocessor.type) &&
    field.params?.preprocessed === true,
  enrich: (field) => {
    field.value = DEVICE_DATA[field.name] ?? null;
  },
};
